module.exports = {
          srcSet: __webpack_public_path__ + "d1a9e389902aad9a01bea638bdb8fb1d-79.png"+" 79w",
          images:[ {path: __webpack_public_path__ + "d1a9e389902aad9a01bea638bdb8fb1d-79.png",width: 79,height: 79}],
          src: __webpack_public_path__ + "d1a9e389902aad9a01bea638bdb8fb1d-79.png",
          toString:function(){return __webpack_public_path__ + "d1a9e389902aad9a01bea638bdb8fb1d-79.png"},
          
          width: 79,
          height: 79
        }